

export default function FinalCTA() {
  const scrollToForm = () => {
    const formSection = document.getElementById('pricing-section');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-purple-600 via-purple-700 to-purple-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-20 h-20 border-2 border-white rounded-full"></div>
        <div className="absolute top-32 right-20 w-16 h-16 border-2 border-white rounded-full"></div>
        <div className="absolute bottom-20 left-32 w-12 h-12 border-2 border-white rounded-full"></div>
        <div className="absolute bottom-32 right-10 w-24 h-24 border-2 border-white rounded-full"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="mb-8">
          <i className="ri-heart-fill text-6xl text-pink-300 mb-6 block"></i>
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight font-montserrat">
            Se Você Está Pronta Para <span className="text-pink-300">Evoluir</span>,<br />
            Eu Estou Pronta Para Te <span className="text-pink-300">Guiar</span>
          </h2>
          <p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto leading-relaxed font-inter">
            Não deixe mais um mês passar sem ver a transformação que você merece. 
            Sua melhor versão está esperando por você.
          </p>
        </div>
        
        <div className="space-y-6 mb-12">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <i className="ri-calendar-check-line text-3xl text-pink-300 mb-3 block"></i>
              <h3 className="font-bold text-white mb-2 font-poppins">30 Dias</h3>
              <p className="text-purple-100 text-sm font-inter">De acompanhamento completo</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <i className="ri-user-heart-line text-3xl text-pink-300 mb-3 block"></i>
              <h3 className="font-bold text-white mb-2 font-poppins">100% Personalizado</h3>
              <p className="text-purple-100 text-sm font-inter">Treino feito especialmente para você</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <i className="ri-trophy-line text-3xl text-pink-300 mb-3 block"></i>
              <h3 className="font-bold text-white mb-2 font-poppins">Resultados Reais</h3>
              <p className="text-purple-100 text-sm font-inter">Transformação comprovada</p>
            </div>
          </div>
        </div>
        
        <div className="space-y-6">
          <button
            onClick={scrollToForm}
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white font-bold text-lg rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer font-poppins"
          >
            <i className="ri-fire-fill mr-2 text-xl"></i>
            Começar Transformação
          </button>
          
          <p className="text-purple-200 text-sm font-poppins">
            ⚡ Últimas vagas disponíveis para este mês
          </p>
        </div>
        
        <div className="mt-16 pt-8 border-t border-white/20">
          <div className="flex items-center justify-center space-x-8">
            <div className="text-center">
              <div className="text-2xl font-bold text-white font-montserrat">300+</div>
              <div className="text-purple-200 text-sm font-poppins">Mulheres transformadas</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white font-montserrat">4.9★</div>
              <div className="text-purple-200 text-sm font-poppins">Avaliação média</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white font-montserrat">97%</div>
              <div className="text-purple-200 text-sm font-poppins">Satisfação</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

